<div class="kerb-weight-input">
  <div style="margin-bottom: 5px">Vehicle Kerb Weight (kg)</div>

  <!--  <div *ngIf="!isTransported" style="margin-top: 10px; width: calc(100% - 20px) !important">-->
  <!--    <p-dropdown-->
  <!--      id="name"-->
  <!--      appendTo="body"-->
  <!--      placeholder="Select kerb weight range"-->
  <!--      [options]="options"-->
  <!--      [(ngModel)]="selectedWeight"-->
  <!--      (ngModelChange)="onSelectedWeightChanged()"-->
  <!--      class="input-field"-->
  <!--      required-->
  <!--    ></p-dropdown>-->
  <!--  </div>-->

  <div style="margin-bottom: 15px">
    <input
      name="kerbWeight"
      required
      class="input-field"
      (keydown)="limitKerbWeight($event)"
      (keyup)="limitKerbWeight($event)"
      [(ngModel)]="kerbWeight"
      (ngModelChange)="onInputWeightChanged()"
      id="kerbWeight"
      #kerbWeightInput="ngModel"
      pattern="^(?:[1-9][0-9]{0,4}(?:\.\d{1,2})?|44000)$"
      [min]="minKerbWeight"
      [max]="maxKerbWeight"
      placeholder="Input kerb weight"
      [ngClass]="{
        'invalid-input': kerbWeightInput.touched &&
        (kerbWeightInput.errors?.['required'] ||
         kerbWeight < minKerbWeight ||
         kerbWeight > maxKerbWeight)
      }"
    />
    <small
      *ngIf="(kerbWeight < minKerbWeight || kerbWeight > maxKerbWeight) && kerbWeightInput.touched"
      style="color: red"
    >
      Kerb weight must be between {{ minKerbWeight }} and {{ maxKerbWeight | number }}.
    </small>
  </div>

  <!--  <div *ngIf="!isTransported" class="warning-box">-->
  <!--    <div class="flex-shrink-1">-->
  <!--      <i class="fa fa-warning" style="color: red"></i>-->
  <!--    </div>-->
  <!--    <div class="flex-grow-1">-->
  <!--      Driven moves require a vehicle kerb weight range. Please select the most accurate option to-->
  <!--      avoid additional charges.-->
  <!--    </div>-->
  <!--  </div>-->

  <div class="warning-box">
    <div class="flex-shrink-1">
      <i class="fa fa-warning" style="color: red"></i>
    </div>
    <div class="flex-grow-1">
      Please input an accurate specific weight in kg (e.g. 1500) to avoid additional charges.
    </div>
  </div>
</div>
